module.exports = __webpack_public_path__ + "img/logo_wetterapp.53f2a4e3.png";